
import TEditor from "@/components/editor/TEditor.vue";
import { ElMessage } from "element-plus";
import { getEnum } from "@/api/index";
import { useRouter, useRoute } from "vue-router";
import { putAbout, getAboutInfo } from "@/api/backstage";
import type { ElForm } from "element-plus";
import Uploadimg from "@/components/uploadimg/Index.vue";
import Uploadfile from "@/components/uploadfile/Index.vue";
import Uploadvideo from "@/components/uploadvideo/Index.vue";
import { useStore } from "vuex";
type FormInstance = InstanceType<typeof ElForm>;
 
import {
  defineComponent,
  reactive,
  computed,
  ref,
  unref,
  toRefs,
  watch,
  onMounted,
} from "vue";
export default defineComponent({
  name: "新增关于我们",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  components: {
    Uploadimg, TEditor,Uploadvideo,
  },

  setup(opt, contex) {
    const store = useStore();
    let isEdit = false;
    let show = opt.open;
    const fileName =  localStorage.getItem("fileUrel") ;
    const router = useRouter();
    const route = useRoute();
    const dataMap: any = reactive({
      ruleFormRef: ref<FormInstance>(),
      dragIndex: "",
      dropIndex: "",
      temp: "",
      index:'',
      aboutUsType: {},
      honour:{},
      ruleForm: {
        title: "",
        fileName:'',
        fileId:'',
        aboutUsType: "",
        description: "",
        sortNum: "",
        others: [{ title: "", fileId: "", description: "", honourType: "" }],
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],

        aboutUsType: [
          { required: true, message: "请选择类型", trigger: "blur" },
        ],
      },

      async getAboutType() {
        dataMap.aboutUsType = {};
        const menus = await getEnum("ABOUT_US");
        for (const item of menus.data) {
          dataMap.aboutUsType[item.enumKey] = item;
        }
      },

      async getHonourType() {
        dataMap.honour = {};
        const menus = await getEnum("HONOUR");
        for (const item of menus.data) {
          dataMap.honour[item.enumKey] = item;
        }
      },


      async getAbout() {
        const res = await getAboutInfo(route.query.id);
        dataMap.ruleForm = res.data;
        for (const item of dataMap.ruleForm.others) {
          if(item.fileName) item.fileName = localStorage.getItem("fileUrel") + item.fileName;
        }
      },

      async putAbout() {
        const res = await putAbout(dataMap.ruleForm);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          router.go(-1);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });

    const removeList = (index: any) => {
      dataMap.ruleForm.others.splice(index, 1);
    };
    const addOther = (index: any) => {
      dataMap.ruleForm.others.push({ title: "", fileId: "", description: "", honourType: "" });
    };

    const getIndex = (index: any) => {
      dataMap.index = index;
    };


    const drag = (e: any, index: any) => {
      dataMap.dragIndex = index;
      dataMap.temp = JSON.parse(JSON.stringify(dataMap.ruleForm.others[index]));
    };
    const allowDrop = (e: any) => {
      e.preventDefault();
    };

    const drop = (e: any, i: any) => {
      dataMap.dropIndex = i;
      dataMap.ruleForm.others.splice(i + 1, 0, dataMap.temp);
      if (dataMap.dragIndex > dataMap.dropIndex) {
        // 后往前拖
        dataMap.ruleForm.others.splice(dataMap.dragIndex + 1, 1);
      } else {
        dataMap.ruleForm.others.splice(dataMap.dragIndex, 1);
      }
    };

    const onSuccess = (val: any) => {
      dataMap.ruleForm.others[dataMap.index].fileId = val.id;
    };

    const onImgSuccess = (val: any) => {
      dataMap.ruleForm.fileId = val.id;
    };
    const submitForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.validate((valid) => {
        if (valid) {
          dataMap.putAbout();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    onMounted(() => {
      if (route.query.id) dataMap.getAbout();
      dataMap.getAboutType();
      dataMap.getHonourType();
    });

    const fileSuccess = (val: any) => {
      if( val.value.length){
        dataMap.ruleForm.others[dataMap.index].fileId = val.value[0].id;
        } else{
         dataMap.ruleForm.others[dataMap.index].fileId= '';
        }  
    };


    return {
      fileName,
      show,
      store,
      isEdit,
      router,
      submitForm,
      onImgSuccess,
      fileSuccess,
      close,
      route,
      addOther,
      removeList,
      onSuccess,
      drag,
      drop,
      getIndex,
      allowDrop,

      ...toRefs(dataMap),
    };
  },
});
